/**
 * Pure helpers for review-queue aging calculations.
 * Extracted from ReviewQueueItem to keep that file as a single-export
 * component file (react-refresh/only-export-components).
 */

export function agingMs(completedAt: string | null, createdAt: string): number {
  const from = completedAt ? new Date(completedAt) : new Date(createdAt);
  return Date.now() - from.getTime();
}

export function formatAging(ms: number): string {
  const mins = Math.floor(ms / 60_000);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ${mins % 60}m`;
  return `${Math.floor(hrs / 24)}d ${hrs % 24}h`;
}

export function agingColor(ms: number): string {
  const hours = ms / 3_600_000;
  if (hours < 4) return 'text-emerald-600 dark:text-emerald-400';
  if (hours < 24) return 'text-amber-600 dark:text-amber-400';
  return 'text-red-600 dark:text-red-400';
}
